var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1053_7599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 4.66667C5.33333 5.37391 5.61428 6.05219 6.11438 6.55229C6.61447 7.05238 7.29275 7.33333 7.99999 7.33333C8.70724 7.33333 9.38552 7.05238 9.88561 6.55229C10.3857 6.05219 10.6667 5.37391 10.6667 4.66667C10.6667 3.95942 10.3857 3.28115 9.88561 2.78105C9.38552 2.28095 8.70724 2 7.99999 2C7.29275 2 6.61447 2.28095 6.11438 2.78105C5.61428 3.28115 5.33333 3.95942 5.33333 4.66667Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14V12.6667C4 11.9594 4.28095 11.2811 4.78105 10.781C5.28115 10.281 5.95942 10 6.66667 10H7",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.6664L14.2333 12.4771C14.3703 12.3442 14.4792 12.1852 14.5537 12.0095C14.6282 11.8338 14.6668 11.645 14.6671 11.4541C14.6674 11.2633 14.6295 11.0743 14.5555 10.8984C14.4816 10.7224 14.3732 10.5631 14.2367 10.4297C13.9581 10.1573 13.5841 10.0044 13.1945 10.0037C12.8048 10.0029 12.4303 10.1544 12.1507 10.4257L12.0013 10.5724L11.8527 10.4257C11.5741 10.1535 11.2003 10.0007 10.8108 10C10.4213 9.99926 10.0469 10.1506 9.76733 10.4217C9.63033 10.5546 9.52134 10.7136 9.44678 10.8892C9.37223 11.0649 9.33363 11.2537 9.33325 11.4446C9.33288 11.6354 9.37075 11.8244 9.44461 12.0003C9.51848 12.1763 9.62685 12.3357 9.76333 12.4691L12 14.6664Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1053_7599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHeart);
export default __webpack_public_path__ + "static/media/user_heart.be8906a2087a49a7fc9efb82d8cf7d48.svg";
export { ForwardRef as ReactComponent };